<!-- Patient_Engagement.vue -->
<template>
  <div class="h-full flex flex-col overflow-y-auto space-y-4 p-4">
    <!-- Log Work Card -->
    <div class="bg-white rounded-lg border border-gray-200 px-5 py-4">
      <WorkLogger
        :patient="{ identifier: patientIdentifier, entityId: entityId }"
        @work-submitted="refreshTimeline"
      />
    </div>

    <!-- Comment -->
    <CommentWidget
      v-if="patientIdentifier && entityId"
      :patient-identifier="patientIdentifier"
      :entity-id="entityId"
      @comment-saved="refreshTimeline"
    />

    <!-- Activity Card -->
    <div class="bg-white rounded-lg border border-gray-200 p-8 flex-1">
      <div class="flex items-center justify-between mb-3">
        <h4 class="text-xs font-semibold text-gray-500 uppercase tracking-wide">Activity</h4>
        <button @click="refreshTimeline" :disabled="loading"
                class="text-xs text-gray-500 hover:text-gray-700 flex items-center gap-1">
          <FontAwesomeIcon :icon="['fas', 'arrows-rotate']" :class="{'animate-spin': loading}" class="text-xs" />
          Refresh
        </button>
      </div>

      <Work_Timeline
        ref="timeline"
        :patient-identifier="patientIdentifier"
        :entity-id="entityId"
        @work-deleted="handleWorkDeleted"
      />
    </div>
  </div>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import Work_Timeline from '@/components/Portal/Task_Tables/Work_Widgets/Work_Timeline.vue';
import WorkLogger from '@/components/Portal/Task_Tables/Work_Widgets/WorkLogger.vue';
import CommentWidget from '@/components/Portal/Task_Tables/Work_Widgets/CommentWidget.vue';

export default {
  name: 'Patient_Engagement',
  components: {
    FontAwesomeIcon,
    Work_Timeline,
    WorkLogger,
    CommentWidget
  },

  props: {
    patientIdentifier: {
      type: String,
      required: true
    },
    entityId: {
      type: Number,
      default: null
    }
  },

  emits: ['show-message'],

  data() {
    return {
      loading: false
    };
  },

  methods: {
    async refreshTimeline() {
      this.loading = true;
      if (this.$refs.timeline) {
        await this.$refs.timeline.fetchWorkItems();
      }
      this.loading = false;
    },

    handleWorkDeleted() {
      this.$emit('show-message', 'Work item deleted', 'success');
    }
  }
};
</script>

<style scoped>
@keyframes spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}
.animate-spin {
  animation: spin 1s linear infinite;
}
</style>
